import { render, staticRenderFns } from "./NpoCard.vue?vue&type=template&id=0e92afaa&scoped=true&"
import script from "./NpoCard.vue?vue&type=script&lang=js&"
export * from "./NpoCard.vue?vue&type=script&lang=js&"
import style0 from "./NpoCard.vue?vue&type=style&index=0&id=0e92afaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e92afaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet})
